import React, {useRef, useState} from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const Input = ({
                   type,
                   label,
                   src,
                   onChange,
                   valueToActive,
                   email,
                   value,
                   fade,
                   fadeOut,
                   disabled,
                   required,
                   hidden,
                   style
               }) => {

    const [activeClass, setActiveClass] = useState("");

    const inputRef = useRef(null);

    return (
        <div
            className={`response input-smooth ${activeClass} ${valueToActive ? "focus-within" : ""} ${fade} ${fadeOut}`}
            id={label + "input"}>
            <input
                name={label}
                id={label}
                type={type}
                className={`input-smooth ${email ? "grey focus-within" : ""}`}
                onFocus={() => {
                    setActiveClass("focus-within");
                    // onFocus();
                }}
                onBlur={() => {
                    // onBlur();
                    value ? setActiveClass("focus-within") : setActiveClass("");
                }}
                onChange={onChange}
                value={value}
                required={required}
                disabled={disabled}
                ref={inputRef}
                hidden={hidden}
                style={style}
            />
            <img src={src}/>
            <label htmlFor={label}>{label}</label>
        </div>
    );
};

Input.propTypes = {
    type: PropTypes.string,
    label: PropTypes.string,
    src: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    email: PropTypes.bool,
    valueToActive: PropTypes.string,
    value: PropTypes.string,
    fade: PropTypes.string,
    fadeOut: PropTypes.string,
    disabled: PropTypes.any,
    ref: PropTypes.string,
    toggleFocusOn: PropTypes.bool,
    required: PropTypes.bool,
    hidden: PropTypes.bool,
    style: PropTypes.object
};

export default Input;